module.exports = "https://static.wanderu.com/static/media/tech-crunch-x2.7360843a.png";